module.exports = __webpack_public_path__ + "455218c.webp";